function Field({ name, label, required, bold, placeholder }) {
  return (
    <div className="vf-m-field">
      <label>
        {label}
        {required && <span className="req">*</span>}
      </label>
      <input
        type="text"
        name={name}
        required={required}
        placeholder={placeholder}
        className={bold ? "vf-m-input bold" : "vf-m-input"}
      />
    </div>
  );
}

function Section({ title, children, subtle }) {
  return (
    <div className={`vf-m-section${subtle ? " subtle" : ""}`}>
      <div className="vf-m-section-title">{title}</div>
      <div className="vf-m-section-body">{children}</div>
    </div>
  );
}

function SubGroup({ title, children }) {
  return (
    <div className="vf-m-subgroup">
      <div className="vf-m-subgroup-title">{title}</div>
      <div className="vf-m-row">{children}</div>
    </div>
  );
}

function MobileTree() {
  return (
    <div className="vf-mobile-tree">
      <Section title="Grandfather">
        <Field name="grandfatherName" label="Grandfather's Name" required bold />
      </Section>

      <Section title="Father">
        <Field name="fatherName" label="Father's Name" required bold />
      </Section>

      <Section title="Uncles">
        <Field name="uncle1" label="Uncle 1" />
        <Field name="uncle2" label="Uncle 2" />
        <Field name="uncle3" label="Uncle 3" />
        <Field name="uncle4" label="Uncle 4" />
      </Section>

      <Section title="Cousins (Uncles' Children)" subtle>
        {[1, 2, 3, 4].map((n) => (
          <SubGroup key={n} title={`Uncle ${n}'s children`}>
            <Field name={`uncle${n}Child1`} label="Child 1" />
            <Field name={`uncle${n}Child2`} label="Child 2" />
          </SubGroup>
        ))}
      </Section>

      <Section title="Self / Member">
        <Field name="selfName" label="Your Name" required bold />
      </Section>

      <Section title="Brothers">
        <Field name="brother1" label="Brother 1" />
        <Field name="brother2" label="Brother 2" />
        <Field name="brother3" label="Brother 3" />
        <Field name="brother4" label="Brother 4" />
      </Section>

      <Section title="Brothers' Children" subtle>
        {[1, 2, 3, 4].map((n) => (
          <SubGroup key={n} title={`Brother ${n}'s children`}>
            <Field name={`brother${n}Child1`} label="Child 1" />
            <Field name={`brother${n}Child2`} label="Child 2" />
          </SubGroup>
        ))}
      </Section>

      <Section title="Sons">
        <Field name="son1" label="Son 1" />
        <Field name="son2" label="Son 2" />
        <Field name="son3" label="Son 3" />
      </Section>

      <Section title="Sons' Children" subtle>
        {[1, 2, 3].map((n) => (
          <SubGroup key={n} title={`Son ${n}'s children`}>
            <Field name={`son${n}Child1`} label="Child 1" />
            <Field name={`son${n}Child2`} label="Child 2" />
          </SubGroup>
        ))}
      </Section>
    </div>
  );
}

export default MobileTree;
